module.exports = __webpack_public_path__ + "img/question_plan.64f9257b.svg";